var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-editar-perfil"},[_c('div',{staticClass:"header"},[_c('Tabs',{attrs:{"tabs":_vm.tabs},on:{"change":_vm.handleTabChange}})],1),_c('div',{staticClass:"paginas"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }